import { setNewPassword } from 'api/auth';
import routes from 'constants/routes';
import { useFormik } from 'formik';
import LoginFooterLayout from 'layouts/LoginLayout/LoginFooterLayout';
import LoginHeaderLayout from 'layouts/LoginLayout/LoginHeaderLayout';
import React, { useState } from 'react';
import { Button, Container, Form, Stack } from 'react-bootstrap';
import { GoEye, GoEyeClosed } from 'react-icons/go';
import { useMutation } from 'react-query';
import { Link, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import history from 'utils/history';
import TrackifyToast from 'utils/toast';
import { SetPasswordValidation } from './AuthValidation';

const SetPassword: React.FC = () => {
  const location = useLocation();
  const [errMsg, setErrMsg] = useState('');
  const params = new URLSearchParams(location.search);
  const token = params.get('token') || '';
  const email = params.get('email') || '';
  if (token === '' || email === '') history.push(routes.auth.login);

  const [type, setType] = useState('password');

  const setPasswordMutation = useMutation((data) => setNewPassword(data), {
    onSuccess: (res: any) => {
      setErrMsg('');
      formik.resetForm();
      TrackifyToast.success('Please login with your password.');
      history.push(routes.auth.login);
    },
    onError: (error: any) => {
      if (error?.response?.data?.error?.details)
        setErrMsg(error?.response?.data?.error?.details[0].message);
      else setErrMsg(error?.response?.data?.error?.message);
    },
  });

  const formik = useFormik({
    initialValues: {
      password: '',
      confirm_password: '',
    },
    validate: SetPasswordValidation,
    onSubmit: (data: any) => {
      data.token = token;
      setPasswordMutation.mutate(data);
    },
    validateOnChange: false,
  });

  const onTogglePassword = (e: React.MouseEvent<SVGElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    setType(type === 'text' ? 'password' : 'text');
  };

  return (
    <>
      <Container className="login">
        <Stack gap={4} className="col-md-6 mx-auto col-12 col-sm-12 col-lg-4">
          <LoginHeaderLayout />
          <div className="p-4 login--inner">
            <h2>Set Password</h2>

            <Form onSubmit={formik.handleSubmit} className="mt-3">
              {errMsg && <p className="alert-danger p-2">{errMsg}</p>}

              <Form.Group className="mb-3 d-flex row ">
                <div
                  className={`set-password--wrap ${
                    formik.errors.password ? 'invalid-password' : ''
                  }`}>
                  <Form.Control
                    type={type}
                    name="password"
                    placeholder="Password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={
                      formik.touched.password && formik.errors.password
                        ? 'form-control is-invalid'
                        : 'form-control'
                    }
                    required
                    value={formik.values.password}
                  />
                  <div className="col">
                    {type === 'text' ? (
                      <GoEyeClosed onClick={onTogglePassword} />
                    ) : (
                      <GoEye onClick={onTogglePassword} />
                    )}
                  </div>
                  {formik.touched.password && formik.errors.password ? (
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.password}
                    </Form.Control.Feedback>
                  ) : null}
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Control
                  type="password"
                  name="confirm_password"
                  placeholder="Confirm Password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.confirm_password &&
                    formik.errors.confirm_password
                      ? 'form-control is-invalid'
                      : 'form-control'
                  }
                  required
                  value={formik.values.confirm_password}
                />
                {formik.touched.confirm_password &&
                formik.errors.confirm_password ? (
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.confirm_password}
                  </Form.Control.Feedback>
                ) : null}
              </Form.Group>

              <Stack gap={2}>
                <Button variant="primary" type="submit">
                  Submit
                </Button>
                <Link className="mx-auto mt-3" to={routes.auth.login}>
                  Back to Login
                </Link>
              </Stack>
            </Form>
          </div>
        </Stack>
        <LoginFooterLayout />
      </Container>
    </>
  );
};

export default SetPassword;
